import { useEffect, useState } from "react";
import QuoteForm from "../../parts/quote/Form";
import Api from "../../Api";
import { useNavigate, useParams } from "react-router-dom";
import { intToBrl } from "../../utils";
import Section from "../../parts/Section";
import { Client, Quote, QuoteItem, QuoteAsForm, UIValue } from "../../types";
import DiscreetMessage from "../../parts/DiscreetMessage";

const MyQuotesUpdate = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [quote, setQuote] = useState<QuoteAsForm | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    Api.myQuotesGetByUuid(uuid!).then(
      ({ quote, client }: { quote: Quote; client: Client }) => {
        setQuote({
          ...quote,
          maxInstallments: quote.maxInstallments.toString(),
          feeMonitoring: intToBrl(quote.feeMonitoring),
          feeInstall: intToBrl(quote.feeInstall),
          feeReview: intToBrl(quote.feeReview),
          discountSale: intToBrl(quote.discountSale),
          discountRent: intToBrl(quote.discountRent),
        });
        setClient(client);
      }
    );
  }, [uuid]);

  if (!quote) return <DiscreetMessage text="Carregando ..." />;

  const updateQuote = (key: string) => (value: UIValue | QuoteItem[]) => {
    setQuote((quote) => ({ ...quote!, [key]: value }));
  };

  const save = async (payload: Quote) => {
    setError(false);
    const result = await Api.myQuotesCreate(quote.clientUuid, payload);
    result.success ? navigate("/meus-orcamentos") : setError(true);
  };

  return (
    <>
      <div className="border-b">
        <Section
          className="p-4 cursor-pointer group"
          onClick={() => navigate("/meus-orcamentos")}
        >
          <div className="text-gray-400 text-sm font-bold">
            Duplicando orçamento para
          </div>
          <div className="truncate text-xl font-bold group-hover:text-gray-300">
            {client!.name}
          </div>
        </Section>
      </div>

      <QuoteForm
        quote={quote}
        onChange={updateQuote}
        onSave={save}
        buttonLabel="Criar"
        error={error}
      />
    </>
  );
};

export default MyQuotesUpdate;
